import {Injectable} from '@angular/core';
import {ParametersDatabase} from "../../databases/parameters.database";

@Injectable({
    providedIn: 'root'
})
export class SqliteAutomaticArticleRepository {

    constructor(private readonly parametersDatabase: ParametersDatabase) {}

    async getAutomaticArticles(serviceCode: string): Promise<any> {
        const page = 0;
        const size = 20;

        const whereClause = ` WHERE serviceCode = '${serviceCode}'`;

        const pagedDocs: any[] = await this.parametersDatabase.queryObjects<any>(
            `SELECT *
         FROM automaticarticle ${whereClause}
         LIMIT ${size} OFFSET ${page * size}`,
            null,
            []
        );

        const totalDocumentsCount: number = await this.parametersDatabase.count(
            `SELECT count(*)
         FROM automaticarticle ${whereClause}`
        );

        return {
            totalElements: totalDocumentsCount,
            totalPages: Math.ceil(totalDocumentsCount / size),
            first: page === 0,
            last: (page + 1) * size >= totalDocumentsCount,
            size: size,
            content: pagedDocs,
            number: page,
            numberOfElements: pagedDocs.length,
            empty: pagedDocs.length === 0
        };
    }

}
